module.exports = __webpack_public_path__ + "static/img/2.f272a3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/solution/2.png
// module id = +D79
// module chunks = 3